<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-8">
        <basic-portlet title="Personal Info" icon="la la-user" :bordered="true">
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group kt-form__group">
                <div class="input-container">
                  <label>Name</label>
                  <div class="input-group kt-input-group">
                    <div class="input-group-prepend">
                      <span
                        class="input-group-text"><i class="la la-user" /></span>
                    </div>
                    <input v-model="user.name" v-validate="'required|alpha_spaces'"
                           type="text" name="name"
                           :class="{'form-control': true, 'kt-input':true, 'has-error': errors.has('name') }"
                           placeholder="Full Name" autocomplete="off"
                           aria-describedby="basic-addon1">
                  </div>
                  <transition name="fade">
                    <p v-show="errors.has('name')" class="help is-danger">
                      {{ errors.first('name') }}
                    </p>
                  </transition>
                </div>
                <div class="input-container">
                  <label>Email</label>
                  <div class="input-group kt-input-group">
                    <div class="input-group-prepend">
                      <span
                        class="input-group-text"><i class="la la-envelope" /></span>
                    </div>
                    <input v-model="user.email" v-validate="'required|email'"
                           type="text" name="email"
                           :class="{'form-control': true, 'kt-input':true, 'has-error': errors.has('email') }"
                           placeholder="Enter Email" autocomplete="off"
                           aria-describedby="basic-addon1">
                  </div>
                  <transition name="fade">
                    <p v-show="errors.has('email')" class="help is-danger">
                      {{ errors.first('email') }}
                    </p>
                  </transition>
                </div>
                <button class="btn btn-ss-standout mt-4" @click="updateUser()">
                  <i class="fa fa-save" />&nbsp;Save Changes
                </button>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <contact-info />
            </div>
            <div class="row">
              <div class="col-12">
                <hr>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <change-password :user="user" :admin="authUserIsAdmin" :sidebar="false" />
            </div>
          </div>
        </basic-portlet>
      </div>
      <div class="col-12 col-md-4">
        <div v-if="sidebar">
          <profile-sidebar />
          <account-info />
        </div>
      </div>
    </div>

    <div class="row row-eq-height">
      <div v-if="authUserIsAdmin && isUploader" class="col-sm-12 col-md-4">
        <uploader-data />
      </div>

      <div v-if="authUserIsSuperAdmin && adminEditing" class="col-12 col-md-8">
        <div class="kt-portlet">
          <div class="kt-portlet__head">
            <div class="kt-portlet__head-label">
              <span class="kt-portlet__head-icon">
                <i class="la la-key" />
              </span>
              <h3 class="kt-portlet__head-title">
                Two Factor Authentication
              </h3>
            </div>
          </div>
          <div class="kt-portlet__body">
            <two-factor-authentication :user_to_edit="user" />
          </div>
        </div>
      </div>
    </div>

    <div class="row row-eq-height">
      <div v-if="authUserIsSuperAdmin" class="col-12">
        <legacy-info :user="user" :sidebar="false" />
      </div>
    </div>
  </div>
</template>

<script>
import ProfileSidebar from "VuePartials/App/Preferences/ProfileSiderbar";
import AccountInfo from "VuePartials/App/Preferences/Tabs/AccountInfo";
import ChangePassword from "VuePartials/App/Preferences/Tabs/ChangePassword";
import UploaderData from "VuePartials/App/Preferences/Tabs/UploaderData";
import LegacyInfo from "VuePartials/App/Preferences/Tabs/LegacyInfo";
import TwoFactorAuthentication from "VuePartials/App/Preferences/TwoFactorAuthentication";
import ContactInfo from "VuePartials/FreshSales/ContactInfo";
import BasicPortlet from "VueComponents/BasicPortlet";

export default {
  name: "PersonalInfo",
  components: {
    BasicPortlet,
    ProfileSidebar,
    ChangePassword,
    UploaderData,
    AccountInfo,
    LegacyInfo,
    TwoFactorAuthentication,
    ContactInfo,
  },
  props: {
    sidebar: {
      type: Boolean,
      required: false,
    },
  },
  data: () => ({
    password_current: null,
    password_confirmation: null,
    password: null,
    formIncomplete: false,
    user: window.user,
    auth_user: null,
  }),
  computed: {
    authUserIsSuperAdmin() {
      return this.auth_user && this.auth_user.is_super_admin;
    },
    authUserIsAdmin() {
      return this.auth_user && this.auth_user.is_admin;
    },
    isUploader() {
      return window.user.is_uploader;
    },
    adminEditing() {
      return this.auth_user && this.auth_user.uuid !== this.user.uuid;
    },
  },
  mounted() {
    if (typeof auth_user !== "undefined") {
      this.auth_user = window.auth_user;
    }
  },
  methods: {
    async updateUser() {
      const form_data = {
        name: this.user.name,
        email: this.user.email,
        user_id: this.user.uuid,
        is_admin: this.user.is_admin,
        is_super_admin: this.user.is_super_admin,
      };

      const result = await this.$validator.validateAll();
      if (result) {
        axios
          .put(`/api/v1/user/${this.user.uuid}`, form_data)
          .then(() => {
            toastr.success("Information updated.");
          })
          .catch((error) => {
            window.handleAxiosError(error);
          });
      } else {
        toastr.error("Some fields have not been completed correctly");
      }
    },
  },
};
</script>

<style scoped lang='scss'>
.input-container {
    margin-bottom: 20px;
}
.control-label {
    padding-top: 7px;
    margin-bottom: 0;
    text-align: right;
}

.input-group-addon {
    color: #c5cdda;
    min-width: 40px;
}

input.has-error {
    border: 1px solid #e73d4a;
}

p.is-danger {
    margin-top: 5px;
    color: #e73d4a;
}
</style>
